// extracted by mini-css-extract-plugin
export var footerBG = "BlogPostHero-module--footerBG--c0fcb";
export var translations = "BlogPostHero-module--translations--b11a6";